<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row>
              <b-col md="12">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item><router-link to="/company-structure/employee">Employee</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="10">
                    <b-button v-b-tooltip.hover.top title="Back" class="mb-2" :to="'/company-structure/employee'" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon></b-button>
                </b-col>
                <b-col md="2">
                    <b-button v-b-tooltip.hover.top title="Edit" class="mb-2 float-right" :to="'/company-structure/employee/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon></b-button>
                </b-col>
            </b-row>
            <div class="border-bottom"></div>
            <b-form class="mt-3 mx-2">
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"><label class="labels">Staff ID</label></b-col>
                            <b-col md="8"><p>{{ model.idStaff !== null ? model.idStaff : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Username</label></b-col>
                            <b-col md="8"><p>{{ model.username !== '' ? model.username : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Full Name</label></b-col>
                            <b-col md="8"><p>{{ model.firstName !== '' ? model.firstName : '-' }} {{model.lastName !== null ? model.lastName : ''}}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Nick Name</label></b-col>
                          <b-col md="8"><p>{{ model.nickName !== '' ? model.nickName : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Identity Number</label></b-col>
                          <b-col md="8"><p>{{ model.icNumber !== '' ? model.icNumber : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Gender</label></b-col>
                          <b-col md="8"><p>{{ model.gender !== 'null' && model.gender !== null ? model.gender : '-' }}</p></b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                          <b-col md="4"><label class="labels">Date of Birth</label></b-col>
                          <b-col md="8"><p>{{ model.dob !== '' ? getDate(model.dob) : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Place of Birth</label></b-col>
                          <b-col md="8"><p>{{ model.pob !== '' ? model.pob : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Blood Type</label></b-col>
                          <b-col md="8"><p>{{ model.bloodType !== 'null' && model.bloodType !== null ? model.bloodType : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Marital Status</label></b-col>
                          <b-col md="8"><p>{{ model.maritalStatus !== 'null' && model.maritalStatus !== null ? model.maritalStatus : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Driver's License</label></b-col>
                          <b-col md="8"><p>{{ model.drivingLicence !== '' ? model.drivingLicence : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Signature</label></b-col>
                          <b-col md="8" v-if="model.signature !== null"><p><i class="fa fa-check" aria-hidden="true"></i></p></b-col>
                          <b-col md="8" v-else><p><i class="fa fa-times" aria-hidden="true"></i></p></b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <div class="border-bottom my-2"/>
                <b-button v-b-toggle.contact-info class="mt-0 mb-2 pl-0" variant="light" style="color:#0056b3!important;">Contact Info <font-awesome-icon icon="chevron-down" class="ml-3"/></b-button>
                <b-collapse id="contact-info">
                    <b-card no-body class="mb-2">
                        <b-row>
                            <b-col md="2"><label class="labels">Current Address</label></b-col>
                            <b-col md="4"><p class="text-justify">{{ model.addressCurrent !== '' ? model.addressCurrent : '-' }}</p></b-col>
                            <b-col md="2"><label class="labels">Address</label></b-col>
                            <b-col md="4"><p class="text-justify">{{ model.address !== '' ? model.address : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="2"><label class="labels">Phone</label></b-col>
                            <b-col md="4" v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'"><p>{{ model.phone !== '' && model.phone !== 'null' && model.phone !== null ? '+60' : '' }} {{ model.phone !== '' && model.phone !== 'null' && model.phone !== null ? model.phone : '-' }}</p></b-col>
                            <b-col md="4" v-else><p>{{ model.phone !== '' && model.phone !== 'null' && model.phone !== null ? '+62' : '' }} {{ model.phone !== '' && model.phone !== 'null' && model.phone !== null ? model.phone : '-' }}</p></b-col>
                            <b-col md="2"><label class="labels">Email</label></b-col>
                            <b-col md="4"><p>{{ model.email !== '' ? model.email : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="2"><label class="labels">Work Phone</label></b-col>
                            <b-col md="4" v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'"><p>{{ model.workphone !== '' && model.workphone !== 'null' && model.workphone !== null ? '+60' : '' }} {{ model.workphone !== '' && model.workphone !== null && model.workphone !== 'null' ? model.workphone : '-' }}</p></b-col>
                            <b-col md="4" v-else><p>{{ model.workphone !== '' && model.workphone !== 'null' && model.workphone !== null ? '+62' : '' }} {{ model.workphone !== '' && model.workphone !== null && model.workphone !== 'null' ? model.workphone : '-' }}</p></b-col>
                            <b-col md="2"><label class="labels">Work Email</label></b-col>
                            <b-col md="4"><p>{{ model.workemail !== '' ? model.workemail : '-' }}</p></b-col>
                        </b-row>
                    </b-card>
                </b-collapse>
                <div class="border-bottom mt-0 mb-2"/>
                <b-button v-b-toggle.emergency-contact class="mt-0 mb-2 pl-0" variant="light" style="color:#0056b3!important;">Emergency Contact <font-awesome-icon icon="chevron-down" class="ml-3"/></b-button>
                <b-collapse id="emergency-contact">
                    <b-card no-body class="mb-2">
                        <b-row>
                            <b-col md="12">
                                <div class="table-responsive">
                                <table class="table table-hovered table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col" width="300"></th>
                                            <th scope="col" width="300">Name</th>
                                            <th scope="col" width="300">Phone</th>
                                            <th scope="col" width="300">Relation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>Primary Contact</strong></td>
                                            <td>{{ model.relationPrimaryName !== '' ? model.relationPrimaryName : '-' }}</td>
                                            <td v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'">{{ model.relationPrimaryPhone !== '' && model.relationPrimaryPhone !== 'null' && model.relationPrimaryPhone !== null ? '+60' : '' }} {{ model.relationPrimaryPhone !== '' && model.relationPrimaryPhone !== null && model.relationPrimaryPhone !== 'null' ? model.relationPrimaryPhone : '-' }}</td>
                                            <td v-else>{{ model.relationPrimaryPhone !== '' && model.relationPrimaryPhone !== 'null' && model.relationPrimaryPhone !== null ? '+62' : '' }} {{ model.relationPrimaryPhone !== '' && model.relationPrimaryPhone !== null && model.relationPrimaryPhone !== 'null' ? model.relationPrimaryPhone : '-' }}</td>
                                            <td>{{ model.relationshipPrimary !== 'null' && model.relationshipPrimary !== null ? model.relationshipPrimary : '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Secondary Contact</strong></td>
                                            <td>{{ model.relationSecondaryName !== '' ? model.relationSecondaryName : '-' }}</td>
                                            <td v-if="$store.getters['account/accountData'].account.timezone !== 'Asia/Jakarta'">{{ model.relationSecondaryPhone !== '' && model.relationSecondaryPhone !== 'null' && model.relationSecondaryPhone !== null ? '+60' : '' }} {{ model.relationSecondaryPhone !== '' && model.relationSecondaryPhone !== null && model.relationSecondaryPhone !== 'null' ? model.relationSecondaryPhone : '-' }}</td>
                                            <td v-else>{{ model.relationSecondaryPhone !== '' && model.relationSecondaryPhone !== 'null' && model.relationSecondaryPhone !== null ? '+62' : '' }} {{ model.relationSecondaryPhone !== '' && model.relationSecondaryPhone !== null && model.relationSecondaryPhone !== 'null' ? model.relationSecondaryPhone : '-' }}</td>
                                            <td>{{ model.relationshipSecondary !== 'null' && model.relationshipSecondary !== null ? model.relationshipSecondary : '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-collapse>
                <div class="border-bottom mt-0 mb-2"/>
                <b-button v-b-toggle.education class="mt-0 mb-2 pl-0" variant="light" style="color:#0056b3!important;">Education<font-awesome-icon icon="chevron-down" class="ml-3"/></b-button>
                <b-collapse id="education">
                    <b-card no-body class="mb-2">
                        <b-row>
                            <b-col md="12">
                                <div class="table-responsive">
                                <table class="table table-hovered table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col" width="400" class="text-center">Level of Education</th>
                                            <th scope="col" width="400" class="text-center">Name of University / School</th>
                                            <th scope="col" width="400" class="text-center">Graduated Year</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="educationList.length > 0">
                                    <tr v-for="education in educationList" :key="education.uuid">
                                        <td class="text-center">{{education.levelEducation !== 'null' && education.levelEducation !== null ? education.levelEducation : '-'}}</td>
                                        <td class="text-center">{{education.schoolName !== '' ? education.schoolName : '-'}}</td>
                                        <td class="text-center">{{education.graduatedYear !== '' ? getYear(education.graduatedYear) : '-'}}</td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else>
                                    <tr>
                                        <td colspan="9" class="text-center">there's no data</td>
                                    </tr>
                                    </tbody>
                                </table>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-collapse>
                <div class="border-bottom mt-0 mb-2"/>
                <b-button v-b-toggle.employment class="mt-0 mb-2 pl-0" variant="light" style="color:#0056b3!important;">Employment<font-awesome-icon icon="chevron-down" class="ml-3"/></b-button>
                <b-collapse id="employment">
                    <b-card no-body class="mb-2">
                        <b-row>
                            <b-col md="6">
                                <b-row>
                                    <b-col md="4"><label class="labels">Company</label></b-col>
                                    <b-col md="8"><p>{{ model.company !== null ? model.company : '-' }}</p></b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4"><label class="labels">Branch</label></b-col>
                                    <b-col md="8"><p>{{ model.branch !== null ? model.branch : '-' }}</p></b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4"><label class="labels">Department</label></b-col>
                                    <b-col md="8"><p>{{ model.department !== null ? model.department : '-' }}</p></b-col>
                                </b-row>
                                <!-- <b-row>
                                    <b-col md="4"><label class="labels">Role</label></b-col>
                                    <b-col md="8"><p>{{ model.role !== null ? model.role : '-' }}</p></b-col>
                                </b-row> -->
                                <b-row>
                                    <b-col md="4"><label class="labels">PIC Name</label></b-col>
                                    <b-col md="8"><p>{{ model.picName !== null ? model.picName : '-' }}  {{ model.picName2 !== null && model.picName !== null ? model.picName2 : '' }}</p></b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6">
                                <b-row>
                                    <b-col md="4"><label class="labels">Employment Type</label></b-col>
                                    <b-col md="8"><p>{{ model.employmentType !== '' ? model.employmentType : '-' }}</p></b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4"><label class="labels">Position</label></b-col>
                                    <b-col md="8"><p>{{ model.position !== '' ? model.position : '-' }}</p></b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4"><label class="labels">Start Work</label></b-col>
                                    <b-col md="8"><p>{{ model.firstDate !== null ? this.$moment(model.firstDate).format('YYYY-MM-DD') : '-' }}</p></b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4"><label class="labels">Leave Quota</label></b-col>
                                    <b-col md="8"><p>{{ model.leaveQuota !== null ? model.leaveQuota : '-' }}</p></b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4"><label class="labels">Job Description</label></b-col>
                                    <b-col md="8"><p class="text-justify">{{ model.jobDesk !== '' ? model.jobDesk : '-' }}</p></b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-collapse>
                <div class="border-bottom mt-0 mb-2"/>
                <b-button v-b-toggle.document class="mt-0 mb-2 pl-0" variant="light" style="color:#0056b3!important;">Document<font-awesome-icon icon="chevron-down" class="ml-3"/></b-button>
                <b-collapse id="document">
                    <b-card no-body class="mb-2">
                        <b-row>
                            <b-col md="2 mt-5"><label class="labels">ID Card</label></b-col>
                                <b-row v-if="model.idCardList.length === 0">
                                    <b-col md="9 mb-3">
                                    <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                                    </b-col>
                                    <b-col md="3 mt-2">
                                    <b-button variant="primary" class="btn-custom" @click="showModalIdCard()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                    </b-col>
                                </b-row>
                            <viewer :images="model.idCardList" v-else>
                                <b-row>
                                    <b-col md="3" v-for="(src, index) in model.idCardList" :key="index">
                                    <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-badge v-else-if="src.split('.').pop() == 'pdf'" class="text-primary my-5 p-1" style="background-color:#007bff!important; color:#fff!important;" :href="src" variant="primary" target="__blank">
                                        <font-awesome-icon icon="file-pdf" /> ID Card File
                                    </b-badge>
                                    <b-img v-else :src="src" class="img-responsive my-3" width="175" height="115"/>
                                    </b-col>
                                    <!--<b-col md="2">
                                    <b-button variant="primary" class="btn-custom" @click="showModalIdCard()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                    </b-col>-->
                                </b-row>
                            </viewer>
                        </b-row>
                        <b-row>
                            <b-col md="2 mt-5"><label class="labels">CV / Resume</label></b-col>
                            <b-row v-if="model.cvResumeList.length === 0">
                                <b-col md="9 mb-3">
                                    <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                                </b-col>
                                <b-col md="3 mt-2">
                                    <b-button variant="primary" class="btn-custom" @click="showModalCvResume()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>
                            </b-row>
                            <viewer :images="model.cvResumeList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.cvResumeList" :key="index">
                                    <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-badge v-else-if="src.split('.').pop() == 'pdf'" class="text-primary my-5 p-1" style="background-color:#007bff!important; color:#fff!important;" :href="src" variant="primary" target="__blank">
                                        <font-awesome-icon icon="file-pdf" /> CV / Resume File
                                    </b-badge>
                                    <b-img v-else :src="src" class="img-responsive my-3" width="175" height="115"/>
                                </b-col>
                                <!--<b-col md="2">
                                  <b-button variant="primary" class="btn-custom" @click="showModalCvResume()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>-->
                            </b-row>
                            </viewer>
                        </b-row>
                        <b-row>
                            <b-col md="2 mt-5"><label class="labels">Study Certification</label></b-col>
                            <b-row v-if="model.studyCertificationList.length === 0">
                                <b-col md="9 mb-3">
                                    <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                                </b-col>
                                <b-col md="3 mt-2">
                                    <b-button variant="primary" class="btn-custom" @click="showModalStudyCertification()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>
                            </b-row>
                            <viewer :images="model.studyCertificationList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.studyCertificationList" :key="index">
                                    <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-badge v-else-if="src.split('.').pop() == 'pdf'" class="text-primary my-5 p-1" style="background-color:#007bff!important; color:#fff!important;" :href="src" variant="primary" target="__blank">
                                        <font-awesome-icon icon="file-pdf" /> Study Certification File
                                    </b-badge>
                                    <b-img v-else :src="src" class="img-responsive my-3" width="175" height="115"/>
                                </b-col>
                                <!--<b-col md="2">
                                  <b-button variant="primary" class="btn-custom" @click="showModalStudyCertification()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>-->
                            </b-row>
                            </viewer>
                        </b-row>
                        <b-row>
                            <b-col md="2 mt-5"><label class="labels">Insurance</label></b-col>
                            <b-row v-if="model.insuranceList.length === 0">
                                <b-col md="9 mb-3">
                                    <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                                </b-col>
                                <b-col md="3 mt-2">
                                    <b-button variant="primary" class="btn-custom" @click="showModalInsurance()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>
                            </b-row>
                            <viewer :images="model.insuranceList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.insuranceList" :key="index">
                                    <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-badge v-else-if="src.split('.').pop() == 'pdf'" class="text-primary my-5 p-1" style="background-color:#007bff!important; color:#fff!important;" :href="src" variant="primary" target="__blank">
                                        <font-awesome-icon icon="file-pdf" /> Insurance File
                                    </b-badge>
                                    <b-img v-else :src="src" class="img-responsive my-3" width="175" height="115"/>
                                </b-col>
                                <!--<b-col md="2">
                                  <b-button variant="primary" class="btn-custom" @click="showModalInsurance()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>-->
                            </b-row>
                            </viewer>
                        </b-row>
                        <b-row>
                            <b-col md="2 mt-5"><label class="labels">Others</label></b-col>
                            <b-row v-if="model.othersList.length === 0">
                                <b-col md="9 mb-3">
                                    <p class="text-secondary text-center border border-radius p-2" style="background-color:#f5f5f5"><b-img :src="'/img/general/Imagexhdpi.png'" class="img-responsive" width="70" height="50"/><br><br><i>No Photo Submitted</i></p>
                                </b-col>
                                <b-col md="3 mt-2">
                                    <b-button variant="primary" class="btn-custom" @click="showModalOthers()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>
                            </b-row>
                            <viewer :images="model.othersList" v-else>
                            <b-row>
                                <b-col md="3" v-for="(src, index) in model.othersList" :key="index">
                                    <p class="text-secondary text-center border p-2" v-if="src === null"><i>No Photo Submitted</i></p>
                                    <b-badge v-else-if="src.split('.').pop() == 'pdf'" class="text-primary my-5 p-1" style="background-color:#007bff!important; color:#fff!important;" :href="src" variant="primary" target="__blank">
                                        <font-awesome-icon icon="file-pdf" /> Others File
                                    </b-badge>
                                    <b-img v-else :src="src" class="img-responsive my-3" width="175" height="115"/>
                                </b-col>
                                <!--<b-col md="2">
                                  <b-button variant="primary" class="btn-custom" @click="showModalOthers()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
                                </b-col>-->
                            </b-row>
                            </viewer>
                        </b-row>
                    </b-card>
                </b-collapse>
            </b-form>
            <b-row>
                <b-col md="12" class="mt-2 mb-1">
                    <b-tabs id="nav-tabs-div" class="border-top">
                        <template v-slot:tabs-end>
                            <b-nav-item @click="activeTab = 'Overtime'" :class="{activeClassy : activeTab === 'Overtime'}">Overtime</b-nav-item>
                            <b-nav-item @click="activeTab = 'Leave'" :class="{activeClassy : activeTab === 'Leave'}">Leave</b-nav-item>
                        </template>
                        <div class="nav-content">
                            <div v-if="activeTab === 'Overtime'" key="roadtax" class="nav-content-detail">
                                <div class="content-detail">
                                <Overtime :profileUuid="model.uuid !== undefined ? model.uuid : null" />
                                </div>
                            </div>
                            <div v-if="activeTab === 'Leave'" key="leave" class="nav-content-detail">
                                <div class="content-detail">
                                <Leave :profileUuid="model.uuid !== undefined ? model.uuid : null" />
                                </div>
                            </div>
                        </div>
                    </b-tabs>
                </b-col>
            </b-row>
            <!-- <b-button class="mt-3" :to="'/company-structure/employee'" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-3 float-right" :to="'/company-structure/employee/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button> -->
            <b-modal ref="my-modal-idCard" centered hide-footer :title="(model.uuid === '' ? 'Add' : 'Edit') + ' ID Card Photo'">
            <form v-on:submit.prevent="doSubmitIdCard">
              <label><strong>Doc</strong></label>
              <div class="expander">
                  <b-form-file :required="true" label="ID Card Photo" v-model="modelIdCard.doc" for-input="idCardGroupFile" :error="errors.first('doc')">
                  </b-form-file>
                </div><br>
                <label for=""><strong>Type</strong></label>
                <b-form-input v-model="modelIdCard.type" readonly placeholder="Enter Type"></b-form-input><br>
                <label for=""><strong>Note</strong></label>
                <b-form-input v-model="modelIdCard.note" placeholder="Enter Note"></b-form-input><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModalIdCard"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
                </form>
            </b-modal>
            <b-modal ref="my-modal-cvResume" centered hide-footer :title="(model.uuid === '' ? 'Add ' : 'Edit ' + 'CV / Resume Photo')">
            <form v-on:submit.prevent="doSubmitCvResume">
                <label><strong>Doc</strong></label>
                <div class="expander">
                    <b-form-file :required="true" accept="image/*, application/pdf" label="CV / Resume Photo" v-model="modelCvResume.doc" for-input="cvResumeGroupFile" :error="errors.first('doc')">
                  </b-form-file>
                </div><br>
                <label for=""><strong>Type</strong></label>
                <b-form-input v-model="modelCvResume.type" readonly placeholder="Enter Type"></b-form-input><br>
                <label for=""><strong>Note</strong></label>
                <b-form-input v-model="modelCvResume.note" placeholder="Enter Note"></b-form-input><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModalCvResume"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            </form>
            </b-modal>
            <b-modal ref="my-modal-studyCertification" centered hide-footer :title="(model.uuid === '' ? 'Add ' : 'Edit ' + 'Study Certification Photo')">
            <form v-on:submit.prevent="doSubmitStudyCertification">
                <label><strong>Doc</strong></label>
                <div class="expander">
                    <b-form-file :required="true" label="Study Certification Photo" v-model="modelStudyCertification.doc" for-input="studyCertificationGroupFile" :error="errors.first('doc')">
                    </b-form-file>
                </div><br>
                <label for=""><strong>Type</strong></label>
                <b-form-input v-model="modelStudyCertification.type" readonly placeholder="Enter Type"></b-form-input><br>
                <label for=""><strong>Note</strong></label>
                <b-form-input v-model="modelStudyCertification.note" placeholder="Enter Note"></b-form-input><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModalStudyCertification"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            </form>
            </b-modal>
            <b-modal ref="my-modal-insurance" centered hide-footer :title="(model.uuid === '' ? 'Add ' : 'Edit ' + 'Insurance Photo')">
            <form v-on:submit.prevent="doSubmitInsurance">
                <label><strong>Doc</strong></label>
                <div class="expander">
                    <b-form-file :required="true" label="Insurance Photo" v-model="modelInsurance.doc" for-input="insuranceGroupFile" :error="errors.first('doc')">
                    </b-form-file>
                </div><br>
                <label for=""><strong>Type</strong></label>
                <b-form-input v-model="modelInsurance.type" readonly placeholder="Enter Type"></b-form-input><br>
                <label for=""><strong>Note</strong></label>
                <b-form-input v-model="modelInsurance.note" placeholder="Enter Note"></b-form-input><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModalInsurance"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            </form>
            </b-modal>
            <b-modal ref="my-modal-others" centered hide-footer :title="(model.uuid === '' ? 'Add ' : 'Edit ' + 'Others Photo')">
            <form v-on:submit.prevent="doSubmitOthers">
                <label><strong>Doc</strong></label>
                <div class="expander">
                    <b-form-file :required="true" label="Others Photo" v-model="modelOthers.doc" for-input="othersGroupFile" :error="errors.first('doc')">
                    </b-form-file>
                </div><br>
                <label for=""><strong>Type</strong></label>
                <b-form-input v-model="modelOthers.type" readonly placeholder="Enter Type"></b-form-input><br>
                <label for=""><strong>Note</strong></label>
                <b-form-input v-model="modelOthers.note" placeholder="Enter Note"></b-form-input><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModalOthers"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            </form>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    import Overtime from './EmployeeTab/Overtime'
    import Leave from './EmployeeTab/Leave'
    Vue.use(Viewer)

    export default {
        name: 'profile-details',
        components: {
            Overtime,
            Leave
        },
        data () {
            return {
                isLoading: false,
                activeTab: null,
                dataAccount: this.$store.getters['account/accountData'],
                apiUrl: {
                    profile: window.AppConfig.apiUrl + 'profile',
                    userDocument: window.AppConfig.apiUrl + 'user-document',
                },
                modelIdCard: {
                    doc: null,
                    type: null,
                    note: null,
                },
                modelCvResume: {
                    doc: null,
                    type: null,
                    note: null
                },
                modelStudyCertification: {
                    doc: null,
                    type: null,
                    note: null
                },
                modelInsurance: {
                    doc: null,
                    type: null,
                    note: null
                },
                modelOthers: {
                    doc: null,
                    type: null,
                    note: null
                },
                model: {
                    uuid: '',
                    firstName: '',
                    lastName: '',
                    username: '',
                    nickName: '',
                    icNumber: '',
                    gender: '',
                    dob: '',
                    pob: '',
                    bloodType: '',
                    maritalStatus: '',
                    drivingLicence: '',
                    addressCurrent: '',
                    address: '',
                    phone: '',
                    workphone: '',
                    email: '',
                    workemail: '',
                    relationPrimaryName: '',
                    relationPrimaryPhone: '',
                    relationshipPrimary: '',
                    relationSecondaryName: '',
                    relationSecondaryPhone: '',
                    relationshipSecondary: '',
                    idStaff: '',
                    signature: null,
                    department: {
                        name: null
                    },
                    company: {
                        name: null
                    },
                    branch: {
                        name: null
                    },
                    firstDate: '',
                    employmentType: {
                        name: null
                    },
                    position: {
                        name: null
                    },
                    role: '',
                    picName: '',
                    picName2: '',
                    leaveQuota: '',
                    jobDesk: '',
                    idCard: null,
                    cvResume: null,
                    studyCertification: null,
                    insurance: null,
                    others: null,
                    idCardList: [],
                    cvResumeList: [],
                    studyCertificationList: [],
                    insuranceList: [],
                    othersList: [],
                },
                educationList: [],
                formData: {
                    name: null,
                    levelEducation: null,
                    schoolName: null,
                    graduatedYear: null,
                },
            }
        },
        mounted () {
            this.getDetail()
            this.getEducation()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.profile + '/' + this.$route.params.uuid).then(response => {
                  this.model.firstName = response.data.firstName !== null && response.data.firstName !== 'null' ? response.data.firstName : '-'
                  this.model.lastName = response.data.lastName !== null && response.data.lastName !== 'null' ? response.data.lastName : ''
                  this.model.username = response.data.username !== null && response.data.username !== 'null' ? response.data.username : '-'
                  this.model.nickName = response.data.nickName !== null && response.data.nickName !== 'null' ? response.data.nickName : '-'
                  this.model.icNumber = response.data.icNumber !== null && response.data.icNumber !== 'null' ? response.data.icNumber : '-'
                  this.model.gender = response.data.gender !== null && response.data.gender !== 'null' ? response.data.gender : '-'
                  this.model.dob = response.data.dob !== null ? this.$moment(response.data.dob).format('YYYY-MM-DD') : null
                  this.model.pob = response.data.pob !== null && response.data.pob !== 'null' ? response.data.pob : '-'
                  this.model.picName = response.data.parent !== null && response.data.parent !== 'null' ? response.data.parent.firstName : '-'
                  this.model.picName2 = response.data.parent !== null && response.data.parent !== 'null' ? response.data.parent.lastName : ''
                  this.model.bloodType = response.data.bloodType !== null && response.data.bloodType !== 'null' ? response.data.bloodType : '-'
                  this.model.maritalStatus = response.data.maritalStatus !== null && response.data.maritalStatus !== 'null' ? response.data.maritalStatus : '-'
                  this.model.drivingLicence = response.data.drivingLicence !== null && response.data.drivingLicence !== 'null' ? response.data.drivingLicence : '-'
                  this.model.addressCurrent = response.data.addressCurrent !== null && response.data.addressCurrent !== 'null' ? response.data.addressCurrent : '-'
                  this.model.address = response.data.address !== null && response.data.address !== 'null' ? response.data.address : '-'
                  this.model.uuid = response.data.uuid
                  this.model.phone = response.data.phone
                  this.model.workphone = response.data.workphone
                  this.model.relationPrimaryPhone = response.data.relationPrimaryPhone
                  this.model.relationSecondaryPhone = response.data.relationSecondaryPhone
                  this.model.email = response.data.email !== null && response.data.email !== 'null' ? response.data.email : '-'
                  this.model.workemail = response.data.workemail !== null && response.data.workemail !== 'null' ? response.data.workemail : '-'
                  this.model.relationPrimaryName = response.data.relationPrimaryName !== null && response.data.relationPrimaryName !== 'null' ? response.data.relationPrimaryName : '-'
                  this.model.relationshipPrimary = response.data.relationshipPrimary !== null && response.data.relationshipPrimary !== 'null' ? response.data.relationshipPrimary : '-'
                  this.model.relationSecondaryName = response.data.relationSecondaryName !== null && response.data.relationSecondaryName !== 'null' ? response.data.relationSecondaryName : '-'
                  this.model.relationshipSecondary = response.data.relationshipSecondary !== null && response.data.relationshipSecondary !== 'null' ? response.data.relationshipSecondary : '-'
                  this.model.idStaff = response.data.idStaff !== null ? response.data.username : '-'
                  this.model.signature = response.data.signature
                  this.model.department = response.data.department !== null && response.data.department.name !== 'null' ? response.data.department.name : '-'
                  this.model.company = response.data.company !== null && response.data.company.name !== 'null' ? response.data.company.name : '-'
                  this.model.branch = response.data.branch !== null && response.data.branch.name !== 'null' ? response.data.branch.name : '-'
                  this.model.firstDate = response.data.firstDate !== null ? this.$moment(response.data.firstDate).format('YYYY-MM-DD') : null
                  this.model.employmentType = response.data.employmentType !== null && response.data.employmentType.name !== 'null' ? response.data.employmentType.name : '-'
                  this.model.position = response.data.position !== null && response.data.position.name !== 'null' ? response.data.position.name : '-'
                //   this.model.role = response.data.role !== null && response.data.role !== 'null' ? response.data.role : '-'
                  this.model.leaveQuota = response.data.leaveQuota !== null && response.data.leaveQuota !== 'null' ? response.data.leaveQuota : '-'
                  this.model.jobDesk = response.data.jobDesk !== null && response.data.jobDesk !== 'null' ? response.data.jobDesk : '-'
                  this.model.account = response.data.account.uuid
                  this.model.idCardList = []
                  this.model.cvResumeList = []
                  this.model.studyCertificationList = []
                  this.model.insuranceList = []
                  this.model.othersList = []
                  if (response.data.userDocument !== null) {
                      response.data.userDocument.forEach(data => {
                          if(data.type === "ID Card") {
                              this.model.idCardList.push(data.url)
                          }
                          if (data.type === "CV / Resume") {
                              this.model.cvResumeList.push(data.url)
                          }
                          if (data.type === "Study Certification") {
                              this.model.studyCertificationList.push(data.url)
                          }
                          if (data.type === "Insurance") {
                              this.model.insuranceList.push(data.url)
                          }
                          if (data.type === "Others") {
                              this.model.othersList.push(data.url)
                          }
                      })
                  }
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getEducation () {
              this.$http.get(window.AppConfig.apiUrl + 'education?limit=100&user_uuid=' + this.$route.params.uuid).then(response => {
                this.educationList = []
                response.data._embedded.education.forEach(data => {
                    this.educationList.push(data)
                    })
                })
            },
            showModalIdCard() {
                this.modelIdCard.type = 'ID Card'
                this.modelIdCard.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-idCard'].show()
            },
            hideModalIdCard () {
                this.resetData()
                this.$refs['my-modal-idCard'].hide()
            },
            showModalCvResume() {
                this.modelCvResume.type = 'CV / Resume'
                this.modelCvResume.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-cvResume'].show()
            },
            hideModalCvResume () {
                this.resetData()
                this.$refs['my-modal-cvResume'].hide()
            },
            showModalStudyCertification() {
                this.modelStudyCertification.type = 'Study Certification'
                this.modelStudyCertification.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-studyCertification'].show()
            },
            hideModalStudyCertification () {
                this.resetData()
                this.$refs['my-modal-studyCertification'].hide()
            },
            showModalInsurance() {
                this.modelInsurance.type = 'Insurance'
                this.modelInsurance.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-insurance'].show()
            },
            hideModalInsurance () {
                this.resetData()
                this.$refs['my-modal-insurance'].hide()
            },
            showModalOthers() {
                this.modelOthers.type = 'Others'
                this.modelOthers.note = null
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal-others'].show()
            },
            hideModalOthers () {
                this.resetData()
                this.$refs['my-modal-others'].hide()
            },
            resetData () {
                this.model.idCardPhoto = null
                this.model.cvResumePhoto = null
                this.model.studyCertificationPhoto = null
                this.model.insurancePhoto = null
                this.model.othersPhoto = null
            },
            doSubmitIdCard () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelIdCard.doc)
                    if (this.modelIdCard.type !== null) {
                        formData.append('type', this.modelIdCard.type)
                    }
                    if (this.modelIdCard.note !== null) {
                        formData.append('note', this.modelIdCard.note)
                    }
                //     this.$http.patch(this.apiUrl.userDocument + '/' + this.model.uuid, formData).then(response => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/success', 'ID Card Photo successfully updated.')
                //         this.getDetail()
                //         this.hideModalIdCard()
                //     }).catch(error => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/error', error)  
                //     }) 
                // } else {
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'ID Card Photo/File successfully added.')
                        this.getDetail()
                        this.hideModalIdCard()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doSubmitCvResume () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelCvResume.doc)
                    if (this.modelCvResume.type !== null) {
                        formData.append('type', this.modelCvResume.type)
                    }
                    if (this.modelCvResume.note !== null) {
                        formData.append('note', this.modelCvResume.note)
                    }
                //     this.$http.patch(this.apiUrl.userDocument + '/' + this.model.uuid, formData).then(response => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/success', 'CV / Resume Photo successfully updated.')
                //         this.getDetail()
                //         this.hideModalCvResume()
                //     }).catch(error => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/error', error)  
                //     }) 
                // } else {
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'CV / Resume Photo/File successfully added.')
                        this.getDetail()
                        this.hideModalCvResume()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doSubmitStudyCertification () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelStudyCertification.doc)
                    if (this.modelStudyCertification.type !== null) {
                        formData.append('type', this.modelStudyCertification.type)
                    }
                    if (this.modelStudyCertification.note !== null) {
                        formData.append('note', this.modelStudyCertification.note)
                    }
                //     this.$http.patch(this.apiUrl.userDocument + '/' + this.model.uuid, formData).then(response => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/success', 'Study Certification Photo successfully updated.')
                //         this.getDetail()
                //         this.hideModalStudyCertification()
                //     }).catch(error => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/error', error)  
                //     }) 
                // } else {
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'Study Certification Photo/File successfully added.')
                        this.getDetail()
                        this.hideModalStudyCertification()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doSubmitInsurance () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelInsurance.doc)
                    if (this.modelInsurance.type !== null) {
                        formData.append('type', this.modelInsurance.type)
                    }
                    if (this.modelInsurance.note !== null) {
                        formData.append('note', this.modelInsurance.note)
                    }
                //     this.$http.patch(this.apiUrl.userDocument + '/' + this.model.uuid, formData).then(response => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/success', 'Insurance Photo successfully updated.')
                //         this.getDetail()
                //         this.hideModalInsurance()
                //     }).catch(error => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/error', error)  
                //     }) 
                // } else {
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'Insurance Photo/File successfully added.')
                        this.getDetail()
                        this.hideModalInsurance()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doSubmitOthers () {
              this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    let formData = new FormData()
                    formData.append('user', this.$route.params.uuid)
                    formData.append('doc', this.modelOthers.doc)
                    if (this.modelOthers.type !== null) {
                        formData.append('type', this.modelOthers.type)
                    }
                    if (this.modelOthers.note !== null) {
                        formData.append('note', this.modelOthers.note)
                    }
                //     this.$http.patch(this.apiUrl.userDocument + '/' + this.model.uuid, formData).then(response => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/success', 'Others Photo successfully updated.')
                //         this.getDetail()
                //         this.hideModalOthers()
                //     }).catch(error => {
                //         this.isLoading = false
                //         this.$store.dispatch('notification/error', error)  
                //     }) 
                // } else {
                    this.$http.post(this.apiUrl.userDocument, formData).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'Others Photo/File successfully added.')
                        this.getDetail()
                        this.hideModalOthers()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                  }
               })
            },
            doEdit (row) {
                this.setData(row)
                this.$refs['my-modal-idCard'].show()
            },
            setData (row) {
                this.model.uuid = row.uuid
                this.model.doc = row.doc
            },
            onFileIdCardPhoto (event) {
                this.modelIdCard.doc = event.target.files[0]
            },
            clearImageIdCardPhoto () {
                this.$refs.doc.value = ''
                this.modelIdCard.doc = null
            },
            onFileCvResumePhoto (event) {
                this.modelCvResume.doc = event.target.files[0]
            },
            clearImageCvResumePhoto () {
                this.$refs.doc.value = ''
                this.modelCvResume.doc = null
            },
            onFileStudyCertificationPhoto (event) {
                this.modelStudyCertification.doc = event.target.files[0]
            },
            clearImageStudyCertificationPhoto () {
                this.$refs.doc.value = ''
                this.modelStudyCertification.doc = null
            },
            onFileInsurancePhoto (event) {
                this.modelInsurance.doc = event.target.files[0]
            },
            clearImageInsurancePhoto () {
                this.$refs.doc.value = ''
                this.modelInsurance.doc = null
            },
            onFileOthersPhoto (event) {
                this.modelOthers.doc = event.target.files[0]
            },
            clearImageOthersPhoto () {
                this.$refs.doc.value = ''
                this.modelOthers.doc = null
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            getDate (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD')
                } else {
                    return '-'
                }
            },
            getYear (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'success'
                    break
                case 1:
                    return 'info'
                    break
                }
            }
        }
    }
</script>